/* eslint-disable prettier/prettier */
/* prettier-ignore-file */

import { useState, useEffect, useCallback } from 'react';
import { countryService, Country } from '../services/countryService';

export const useCountries = () => {
	const [countries, setCountries] = useState<Country[]>([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchCountries = useCallback(async () => {
		try {
			setLoading(true);
			setError(null);

			const data = await countryService.getAllCountries();
			setCountries(data);
		} catch (err: any) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		fetchCountries();
	}, [fetchCountries]);

	return {
		countries,
		loading,
		error,
		refetch: fetchCountries,
	};
};
